export const TypeAngles = {
    "Tipo E": 5,
    "Tipo H1": 0,
    "Vitta": 90,
    "Delux": 22,
    "Classic": 90,
}